import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { SessionGuard } from './guards/session.guard';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './login/change-password/change-password.component';

import { DashboardGuard } from './guards/dashboard.guard';
import { ArchivosGuard } from './guards/archivos.guard';
import { UsuariosGuard } from './guards/usuarios.guard';
import { AreasGuard } from './guards/areas.guard';
import { PerfilesGuard } from './guards/perfiles.guard';
import { CedulasGuard } from './guards/cedulas.guard';
import { ReportsGuard } from './guards/reports.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login', // <-- Ruta temporal
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [SessionGuard, DashboardGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canActivate: [SessionGuard, ReportsGuard]
  },
  {
    path: 'file-manager',
    loadChildren: () => import('./file-manager/file-manager.module').then(m => m.FileManagerModule),
    canActivate: [SessionGuard, ArchivosGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canActivate: [SessionGuard, UsuariosGuard]
  },
  {
    path: 'areas',
    loadChildren: () => import('./areas/areas.module').then(m => m.AreasModule),
    canActivate: [SessionGuard, AreasGuard]
  },
  {
    path: 'profiles',
    loadChildren: () => import('./profiles/profiles.module').then(m => m.ProfilesModule),
    canActivate: [SessionGuard, PerfilesGuard]
  },
  {
    path: 'cedulas',
    loadChildren: () => import('./cedulas/cedulas.module').then(m => m.CedulasModule),
    canActivate: [SessionGuard, CedulasGuard]
  },
  {
    path: '**',
    component: NotFoundPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
